import { action, register, types } from "@gadgetinc/mobx-quick-tree";
import { GadgetDomainModelClass, contentHash, getAppSettings } from "../utils";
import { encryptApplicationSecret } from "../appSecrets";

@register
export class GoogleOAuthCredentials extends GadgetDomainModelClass("GoogleOAuthCredentials", {
  gadgetManaged: types.boolean,
  clientID: types.maybe(types.string),
  clientSecret: types.maybe(types.string),
}) {
  get contentHash() {
    return contentHash([this.gadgetManaged, this.clientID, this.clientSecret]);
  }

  @action
  setGadgetManaged(value: boolean) {
    this.gadgetManaged = value;
  }

  @action
  setClientID(value: string | undefined) {
    this.clientID = value;
  }

  @action
  setClientSecret(value: string | undefined) {
    const publicKey = getAppSettings(this).secretsPublicKey;

    this.clientSecret = value ? encryptApplicationSecret(value, publicKey) : undefined;
  }
}
